export default __webpack_public_path__ + "static/media/IndividualUserUpgrade.efe660af.svg";